import React, { useContext, useState, useEffect } from 'react';
import { StyledCitiesFilterDiv, StyledCitiesFilterHeaderContainerDiv } from './index.styles';
import { StyledCheckboxItemDiv, StyledCheckboxItemsContainer } from '../../organisms/SearchResults/index.styles';
import { useSessionUpdateContext } from '../../context/SessionUpdateContext';
import { SearchFilterContext } from '../../organisms/SearchResults/index.context';
import { SearchFacetsList, SearchFacetsListCodes } from '../../organisms/SearchResults/index.constant';
import {
  SearchFacetsResponse,
  SearchFacetsResponseBuckets,
  SearchStateExtendsType,
  SearchStateFilterObj,
} from '../../organisms/SearchResults/store/store.type';
import { CheckBox, checkboxVariation } from '@marriott/mi-ui-library';
import { formatNumberByLocale } from '../../utils';
import { useWindowSize } from '../../hooks';
import { usePageContext } from '../../context/PageContext/index';
import clsx from 'clsx';

declare module 'react' {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface HTMLAttributes<T> {
    custom_click_track_value?: string;
  }
}

export const CityFilterComponent: React.FC<{
  onItemSelect: (arg: SearchFacetsList, arg2: SearchStateFilterObj) => void;
  clearFilterState: SearchStateExtendsType | undefined | null;
  citiesList?: SearchFacetsResponse;
}> = ({ onItemSelect, clearFilterState, citiesList }) => {
  const { searchQueryState } = useContext(SearchFilterContext);
  const { currentLocale } = usePageContext();
  const { interactionsSelected, setInteractionsSelected } = useSessionUpdateContext();
  const clickTrackingLoc = 'Phoenix Search Results';
  const getCurrCityList = (): SearchFacetsResponse =>
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    citiesList ?? searchQueryState?.filter?.filter((key: any) => key.type.code === SearchFacetsListCodes.cities)[0];
  const [currSelectedItem, setCurrSelectedItem] = useState<SearchStateFilterObj | undefined>(
    searchQueryState[SearchFacetsList.cities]
  );

  const [cityList, setCityList] = useState<SearchFacetsResponse>(getCurrCityList());
  const { width } = useWindowSize();

  useEffect(() => {
    setCityList(getCurrCityList());
  }, [citiesList]);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onSelectionChange = (event: any, data: SearchFacetsResponseBuckets): void => {
    if (event.key === 'Enter' || event.type === 'click' || event.type === 'change' || event.keyCode === 13) {
      let obj: SearchStateFilterObj | undefined = { ...currSelectedItem };
      if (obj !== undefined) {
        if (data.code in obj) {
          delete obj[data.code];
        } else {
          obj[data.code] = data.code;
        }
      } else {
        obj = {};
        obj[data.code] = data.code;
      }
      setCurrSelectedItem(obj);
      if (onItemSelect) {
        onItemSelect(SearchFacetsList.cities, obj);
      }
    }
    setInteractionsSelected({ ...interactionsSelected, city: true });
  };

  useEffect(() => {
    if (clearFilterState === undefined || clearFilterState === null) {
      setCurrSelectedItem(undefined);
    }
  }, [clearFilterState]);
  return cityList?.type?.count ? (
    <StyledCitiesFilterDiv className="t-font-alt-m color-scheme1">
      <fieldset>
        <StyledCitiesFilterHeaderContainerDiv className="t-font-alt-m color-scheme1">
          <legend>
            <h4
              className={clsx(
                width && width > 1024 ? `t-subtitle-l` : width && width > 767 ? `t-subtitle-l` : `t-subtitle-m`,
                'filter-heading',
                'pb-1',
                'mb-1'
              )}
            >
              {cityList?.type?.label}
            </h4>
          </legend>
        </StyledCitiesFilterHeaderContainerDiv>
        <StyledCheckboxItemsContainer>
          {cityList?.buckets
            ?.filter((city: SearchFacetsResponseBuckets) => city?.label)
            ?.map((city: SearchFacetsResponseBuckets, idx: number) => (
              <StyledCheckboxItemDiv
                className={clsx('m-checkbox-selection-item', 'amenity-description', 'color-scheme1', 'cities-filters')}
                key={idx}
              >
                <CheckBox
                  variation={checkboxVariation.SIMPLE}
                  className=""
                  checkboxId={`${city?.code?.toString()?.split(' ').join('-')}-checkbox`}
                  checkboxName="city_filter_checkbox"
                  onChange={(e): void => onSelectionChange(e, city)}
                  onKeyDown={(e): void => onSelectionChange(e, city)}
                  checked={currSelectedItem ? city.code in currSelectedItem === true : false}
                  inputClassName="checkbox-input custom_click_track"
                  setTabIndex={-1}
                  children={
                    <>
                      <span className="t-font-s item-name">{city?.label}</span>
                      {city?.count && (
                        <span className="t-font-s pl-1">({formatNumberByLocale(city?.count, currentLocale)})</span>
                      )}
                    </>
                  }
                  {...{ custom_click_track_value: `${clickTrackingLoc}| City options:${city?.label} |internal` }}
                />
              </StyledCheckboxItemDiv>
            ))}
        </StyledCheckboxItemsContainer>
      </fieldset>
    </StyledCitiesFilterDiv>
  ) : null;
};
